import Vue from 'vue';
import CartPreviewActions from './CartPreviewActions.vue';
import CartPreviewItem from './CartPreviewItem.vue';
export default Vue.extend({
    components: { CartPreviewItem, CartPreviewActions },
    props: {
        item: Object,
    },
});
